export type LatLong = {
	latitude: number;
	longitude: number;
};
export const getLatLong = (latitude: number | undefined | null, longitude: number | undefined | null): LatLong | null => (
	!!latitude && !!longitude ? { latitude, longitude } : null
);

export type StaticMapOptions = {
	center: LatLong;
	marker: LatLong;
	width: number;
	height: number;
	zoom: number;
};
export type MapsServiceConfig = {
	apiKey: string;
};
export class MapsService {
	static #BASE_STATIC_MAP_URL = "https://maps.googleapis.com/maps/api/staticmap";

	readonly #apiKey: string;

	constructor(config: MapsServiceConfig) {
		this.#apiKey = config.apiKey;
	}

	staticMapUrl(options: StaticMapOptions): string {
		const params = new URLSearchParams({
			center: options.center.latitude + "," + options.center.longitude,
			markers: options.marker.latitude + "," + options.marker.longitude,
			size: options.width + "x" + options.height,
			zoom: options.zoom.toString(),
			key: this.#apiKey,
		});

		return MapsService.#BASE_STATIC_MAP_URL + "?" + params.toString();
	}

	get apiKey(): string {
		return this.#apiKey;
	}
}